// Copiar texto (código e link de convite) para a área de transferência (0.65, Texto 4 E).
// Usa o expo-clipboard só se o app instalado já tem esse módulo (versões antigas: compartilha o texto).
import { Platform, Share } from 'react-native';
import { requireOptionalNativeModule } from 'expo-modules-core';

export async function copiarTexto(texto: string): Promise<boolean> {
  try {
    if (Platform.OS === 'web') { await navigator.clipboard.writeText(texto); return true; }
    if (requireOptionalNativeModule('ExpoClipboard')) {
      const Clip = require('expo-clipboard') as typeof import('expo-clipboard');
      await Clip.setStringAsync(texto);
      return true;
    }
  } catch { /* cai no compartilhar */ }
  await Share.share({ message: texto }).catch(() => {});
  return false;
}
